import { useEffect, useState } from "react";
import { isBefore, isAfter, addDays, subDays } from "date-fns";

import useData from "../../hooks/useData";
import useSurvey from "../../hooks/useSurvey";

import { Box, Stack, Typography } from "@mui/material";

import SurveyQuestion from "./SurveyQuestion";
import Loading from "./Loading";

const SurveyEntry_SectionQuestion = ({
  matrixItem,
  sku,
  callResultId,
  section,
  questions,
  answers,
  call,
  location,
  onChange,
  isDisabled,
  testMode = false,
}) => {
  const { newId, sortByFields } = useData();
  const { getQuestionVariabilityData, showQuestion } = useSurvey();

  const [sectionQuestions, setSectionQuestions] = useState(null);

  useEffect(() => {
    getActiveQuestions();
  }, [answers, questions, location]);

  const getActiveQuestions = async () => {
    setSectionQuestions(null);
    let list = [];
    for (const question of questions) {
      if (question.surveySectionId !== section.id) continue;
      // const show = await showQuestion({
      //   question,
      //   answers,
      //   location,
      //   skuId: sku ? sku.id : null,
      // });
      // if (!show) continue;

      list.push(question);
    }

    const sorted = sortByFields(list, ["questionNumber"]);

    setSectionQuestions(sorted);
  };

  const getAnswer = (question) => {
    if (!Array.isArray(answers)) return null;

    let answer = null;

    if (matrixItem) {
      answer = answers.find(
        (a) =>
          a.surveyQuestionId === question.id &&
          a.matrixItemId === matrixItem.id,
      );
    } else if (sku) {
      answer = answers.find(
        (a) => a.surveyQuestionId === question.id && a.skuId === sku.id,
      );
    } else {
      answer = answers.find((a) => a.surveyQuestionId === question.id);
    }

    if (answer) {
      return answer;
    }

    return null;
  };

  const handleChange = (question, newValue) => {
    if (isDisabled) return;

    let newAnswer = null;

    let currentAnswer = null;
    if (matrixItem) {
      currentAnswer = answers.find(
        (a) =>
          a.surveyQuestionId === question.id &&
          a.matrixItemId === matrixItem.id,
      );
    } else if (sku) {
      currentAnswer = answers.find(
        (a) => a.surveyQuestionId === question.id && a.skuId === sku.id,
      );
    } else {
      currentAnswer = answers.find((a) => a.surveyQuestionId === question.id);
    }

    if (currentAnswer) {
      newAnswer = { ...currentAnswer, value: newValue };
    } else {
      newAnswer = {
        localId: newId(),
        callResultId,
        surveyId: section.surveyId,
        surveyPageId: section.surveyPageId,
        surveySectionId: section.id,
        surveyQuestionId: question.id,
        questionType: question.questionType,
        matrixItemId: matrixItem ? matrixItem.id : null,
        skuId: sku ? sku.id : null,
        requiresQA: question.requiresQA ?? false,
        value: newValue,
        questionConfig: question.config || {},
      };
    }

    onChange(newAnswer);
  };

  if (!sectionQuestions) return <Loading />;

  if (sectionQuestions.length === 0 && !section.variability)
    return (
      <Box sx={{ padding: "10px" }}>
        <Typography sx={{ fontSize: "10px" }}>
          No active questions available
        </Typography>
      </Box>
    );

  return (
    <Box sx={{ marginTop: "8px" }}>
      <Stack>
        {Array.isArray(questions)
          ? sectionQuestions.map((question, index) => (
              <Box key={question.id}>
                <SurveyQuestion
                  section={section}
                  question={question}
                  questions={questions}
                  location={location}
                  call={call}
                  sku={sku}
                  answer={getAnswer(question)}
                  answers={answers}
                  onChange={(newValue) => handleChange(question, newValue)}
                  isDisabled={isDisabled}
                  testMode={testMode}
                />
              </Box>
            ))
          : null}
      </Stack>
    </Box>
  );
};

export default SurveyEntry_SectionQuestion;
